import type { BuilderStep } from '../types';
import { getStepIndex } from './getStepIndex';

/**
 * A step is accessible once the user has reached at least that point in the
 * flow. `maxStep` tracks the furthest step the user has unlocked.
 */
export const isStepAccessible = (step: BuilderStep, maxStep: BuilderStep) =>
  getStepIndex(step) <= getStepIndex(maxStep);
